import { Tabs, Row } from 'antd';

import styled from 'styled-components';

import { transactionTableBaseStyles } from '@components/Transactions/TransactionListStyles';

export const ProjectTransactionFormContainer = styled.div`
    .previsional {
        .label {
            font-size: ${(props) => props.theme.FontSizeSm};
            margin-bottom: 0.5rem;
            text-transform: uppercase;
        }
        .transaction-item {
            margin-bottom: 0.5rem;
        }
        .amount {
            color: ${(props) => props.theme.PrimaryColor};
            text-decoration: underline;
            cursor: pointer;
            font-weight: bold;
        }
        .description {
            font-size: 14px;
        }
        margin-bottom: 16px;
    }
    .model-wrapper {
        margin-bottom: 16px;

        .model-name {
            margin-bottom: 16px;
            font-size: 18px;
            font-weight: bold;
        }
        .event-name {
            margin-left: 16px;
        }
    }
    .rate-form {
        border-right: ${(props) => props.theme.LighterBorder};
    }
    .hours-container {
        .nw-form-item-container {
            margin-left: 8px;
            margin-right: 8px;
            .ant-form-item {
                margin-bottom: 0;
            }
        }
    }
    .event-container {
        width: calc(100% - 120px);
    }
    .event-hours {
        margin-left: 50%;
    }
    .inclusive-agency-fee {
        background-color: ${(props) => props.theme.LighterBorderColor};
        padding: 0.5rem 1rem 0.25rem 1rem;
        border-radius: 4px;
        border: ${(props) => props.theme.DefaultBorder};
        margin: 0.5rem 0;
        span {
            font-size: ${(props) => props.theme.FontSizeSm};
            button {
                margin-right: 1rem;
            }
        }
    }
    .payroll {
        background-color: ${(props) => props.theme.LighterBorderColor};
        padding: 0.5rem 1rem 0.75rem 1rem;
        border-radius: 4px;
        border: ${(props) => props.theme.DefaultBorder};
        margin: 0.5rem 0;
        span {
            font-size: ${(props) => props.theme.FontSizeSm};
            button {
                margin-right: 1rem;
            }
        }
        .payroll-amount {
            display: block;
            margin: 0.5rem 1rem 0 4rem;
        }
        .payroll-not-allowed {
            color: ${(props) => props.theme.DangerColor};
            font-size: ${(props) => props.theme.FontSizeSm};
            margin: 0.15rem 1rem 0 4rem;
        }
    }
`;

export const AddNewLink = styled.div`
    cursor: pointer;
    text-decoration: underline;
    color: ${(props) => props.theme.PrimaryColor};
`;

export const UsageContainer = styled.div`
    margin-bottom: 24px;

    .ant-form-item {
        margin-bottom: 4px !important;
    }
`;

export const ModelSelectorContainer = styled.div`
    margin: 0.5rem 0;

    h1 {
        font-size: 1.2rem;
        margin-bottom: 1rem;
    }

    h2 {
        font-size: 1.2rem;
        margin-bottom: 0.5rem;
    }

    .is-cancelled {
        ${(props) => props.theme.RedLineThrough(2)}
    }
    .is-confirmed {
        font-weight: bold !important;
    }

    .model-and-previous-events {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 1rem;

        .previous-events-button {
            font-size: 1rem;
        }
    }

    .set-hours {
        margin-top: 1rem;
    }
    .set-units {
        margin-top: 1rem;
    }
    .group-days {
        margin-top: 0.5rem;
    }
    .show-cancelled-dates {
        margin-top: 0.5rem;
    }

    .models {
        .model-units-quantity {
            margin-top: 0.5rem;
        }

        .model {
            padding: 0.5rem 0 0.5rem 0.25rem;

            .model-name-wrapper {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 0.5rem;

                div.model-name {
                    margin-bottom: 0;
                    line-height: 1.1em;
                    font-size: ${(props) => props.theme.FontSizeLg};
                }
                div.all-selectors {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    flex-wrap: nowrap;
                }
            }

            .model-general {
                margin-bottom: 1rem;
            }

            .model-date {
                padding: 0.25rem 0;
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;

                .event-details {
                    .event-details-name {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;

                        &.is-cancelled {
                            ${(props) => props.theme.RedLineThrough(2)}
                        }
                    }
                    .event-details-date {
                        font-weight: bold;
                        span {
                            display: block;
                        }
                    }
                    .event-details-days-quantity {
                        padding: 0.25rem;
                    }
                    .event-details-hours-quantity {
                        padding: 0.25rem;
                    }
                }
            }

            .event-details {
                .event-details-count {
                    color: ${(props) => props.theme.TextColorMuted};
                    margin: 0.5rem 0 0.25rem 0;
                    font-size: ${(props) => props.theme.FontSizeSm};
                }
            }
        }
    }
`;

export const TransactionDrawerContent = styled.div`
    padding-bottom: 10rem;

    .ant-segmented {
        margin-bottom: 2rem;
        .ant-segmented-item-label {
            div {
                padding: 0.75rem 0.25rem 0.5rem 0.25rem;
                h2 {
                    font-weight: bold;
                    text-transform: uppercase;
                    font-size: 1rem;
                    line-height: 1.25em;
                    margin: 0;
                    padding: 0;

                    span {
                        font-size: 0.75rem;
                        vertical-align: top;
                        padding: 0 0.5rem;
                    }
                }
                small {
                    margin: 0;
                    padding: 0;
                    line-height: 1.1em;
                    overflow: none;
                    text-overflow: none;
                    white-space: normal;
                    display: block;
                }
            }
        }
    }
`;

export const StyledTabs = styled(Tabs)`
    padding-bottom: 4rem;

    .ant-tabs-nav-list {
        justify-content: flex-start !important;
    }

    .ant-tabs-nav {
        position: initial !important;
        right: unset !important;
        top: unset !important;
        width: unset !important;
        z-index: unset !important;
        margin: unset !important;
        padding-right: 0 !important;

        .ant-tabs-nav-wrap {
            padding-left: 4rem;
            border-bottom: 1px solid #f0f0f0;
            position: initial !important;
        }
        .ant-tabs-extra-content {
            padding: 0.75rem 0.75rem 0 0;
            border-bottom: 1px solid #f0f0f0;
            min-height: 3.2rem;
        }
    }
`;

export const ProjectTransactionListContainer = styled.div`
    ${transactionTableBaseStyles}

    .transactions-container {
        .ant-table {
            tfoot.ant-table-summary {
                tr {
                    td {
                        border-top: 2px solid ${(props) => props.theme.PrimaryColor} !important;
                        box-shadow: inset 0 2px 0 ${(props) => props.theme.PrimaryColor};
                    }
                }

                .summary-icon-wrapper {
                    color: ${(props) => props.theme.TextColor};
                    font-size: 1.25rem;
                    line-height: 1;
                    opacity: 0.5;
                    padding-top: 0.75rem;
                    text-align: center;
                }
            }
        }
    }

    .subject-container {
        .date-container {
            .dates-without-transactions {
                padding: 1rem 1.5rem 1rem 0.25rem;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 1rem;

                div.icon-wrapper {
                    font-size: 2rem;
                    padding-left: 1rem;
                }

                p {
                    margin: 0;
                    font-weight: bold;
                    max-width: 11rem;
                }
                div.dates-wrapper {
                    flex: 1 1 0;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex-wrap: wrap;
                    .date-item {
                        padding: 0.15rem 0.5rem;
                        margin: 0 0.25rem 0.25rem 0;
                        background-color: ${(props) => props.theme.LighterBorderColor};
                        border-radius: 4px;
                        white-space: nowrap;
                        display: inline-block;
                    }
                }
            }
        }
    }

    .transactions-status-legend-container {
        margin: 4rem 1rem 1rem 1rem;
    }
`;

export const StyledRow = styled(Row)`
    .ant-form-item {
        margin-bottom: 0;
    }
`;

export const CostContainer = styled.div`
    margin-bottom: 24px;
`;

export const EventLabelPanel = styled.div`
    display: flex;
    align-items: center;
`;

export const EventName = styled.div`
    margin-left: 8px;
`;
